import { pickBy, identity } from "lodash";

export const truthyOnly = (obj: Record<string, any>) => pickBy(obj, identity);

